//Redux
import { useAppDispatch, useAppSelector } from "../../app/hooks";
import { closeModal } from "../../reducers/modalReducer";
//Components
import { Modal } from "@allaria-tech/matter/Modal";
//Styles
import styles from "./RiskProfileModal.module.scss";
//Utils
import { riskProfileModalTexts } from "../../i18n/securities/riskPorfileModal";

const RiskProfileModal = ({ language }: { language: "es" | "en" }) => {
  const { container, item } = styles;

  const dispatch = useAppDispatch();

  const { modalName } = useAppSelector((state) => state.modal);

  const isMobile = window.innerWidth < 768;

  const handleClose = () => {
    dispatch(closeModal());
  };

  return (
    <Modal
      isOpen={modalName === "risk-profile-securities"}
      onClose={handleClose}
      title={riskProfileModalTexts[language].header}
      // Matter goes full-screen below 768px, where the corner X is easy to
      // miss, so the close action gets a footer button of its own.
      primaryAction={
        isMobile
          ? { text: riskProfileModalTexts[language].close, onClick: handleClose }
          : undefined
      }
      footerAlignment="right"
    >
      <section className={container}>
        <div className={item}>
          <p>{riskProfileModalTexts[language].conservativeProfileTitle}</p>
          <p>{riskProfileModalTexts[language].conservativeProfile}</p>
        </div>
        <div className={item}>
          <p>{riskProfileModalTexts[language].moderateProfileTitle}</p>
          <p>{riskProfileModalTexts[language].moderateProfile}</p>
        </div>
        <div className={item}>
          <p>{riskProfileModalTexts[language].aggressiveProfileTitle}</p>
          <p>{riskProfileModalTexts[language].aggressiveProfile}</p>
        </div>
        <div className={item}>
          <p>{riskProfileModalTexts[language].especulativeProfileTitle}</p>
          <p>{riskProfileModalTexts[language].especulativeProfile}</p>
        </div>
      </section>
    </Modal>
  );
};

export default RiskProfileModal;
